import { render, staticRenderFns } from "./QueueBook.vue?vue&type=template&id=7ed2ae4a&"
import script from "./QueueBook.vue?vue&type=script&lang=js&"
export * from "./QueueBook.vue?vue&type=script&lang=js&"
import style0 from "./QueueBook.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports